import React from "react";
import Marquee from "../ui/Marquee";
import Magnetic from "../ui/Magnetic";
import Button from "../ui/Button";
import ArrowRight from "../ui/ArrowRight";
import { RevealText } from "../ui/Reveal";

const socials = [
	{ label: "GitHub", href: "https://github.com/RosieOh", handle: "@RosieOh" },
	{ label: "LinkedIn", href: "https://www.linkedin.com/in/dhxogns920", handle: "dhxogns920" },
	{ label: "Email", href: "mailto:dhxogns920@gmail.com", handle: "dhxogns920@gmail.com" },
];

export default function Footer() {
	return (
		<footer className="relative overflow-hidden border-t border-edge bg-surface-sunken">
			{/* 바닥 광원 */}
			<div className="pointer-events-none absolute -bottom-40 left-1/2 h-80 w-[70vw] -translate-x-1/2 rounded-full bg-accent/10 blur-[140px]" />

			<Marquee
				className="border-b border-edge py-5 font-display text-2xl font-semibold uppercase tracking-tight text-content-muted sm:text-4xl"
				items={["Available for work", "Backend & Platform", "Seoul · Remote", "2026"]}
				duration={28}
			/>

			<div className="container relative py-20 lg:py-28">
				<div className="grid gap-14 lg:grid-cols-[1.4fr_1fr]">
					<div>
						<p className="eyebrow mb-6">Get in touch</p>
						<h2 className="font-display text-d2">
							<RevealText text="LET'S" /> <br />
							<span className="stroke-text">
								<RevealText text="BUILD IT." delay={0.12} />
							</span>
						</h2>
						<p className="mt-8 max-w-md text-content-tertiary leading-relaxed">
							새로운 시스템을 설계하거나, 이미 굴러가는 시스템을 더 빠르고 단단하게 만드는 일.
							둘 다 좋아합니다. 편하게 연락 주세요.
						</p>

						<Magnetic strength={0.25} className="mt-10 inline-block">
							<Button as="a" href="mailto:dhxogns920@gmail.com" variant="accent" size="lg" className="font-display font-semibold">
								메일 보내기
								<ArrowRight />
							</Button>
						</Magnetic>
					</div>

					<div className="flex flex-col justify-end">
						<ul className="divide-y divide-edge border-y border-edge">
							{socials.map((social) => (
								<li key={social.label}>
									<a
										href={social.href}
										target={social.href.startsWith("http") ? "_blank" : undefined}
										rel="noopener noreferrer"
										className="group flex items-center justify-between py-5 transition-colors hover:text-accent"
									>
										<span className="font-mono text-[11px] uppercase tracking-[0.2em] text-content-muted group-hover:text-accent">
											{social.label}
										</span>
										<span className="flex items-center gap-3 text-sm text-content-secondary group-hover:text-accent">
											{social.handle}
											<svg className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
												<path d="M7 17 17 7M9 7h8v8" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
										</span>
									</a>
								</li>
							))}
						</ul>
					</div>
				</div>

				<div className="mt-16 flex flex-col gap-3 border-t border-edge pt-8 font-mono text-[11px] uppercase tracking-[0.18em] text-content-faint sm:flex-row sm:items-center sm:justify-between">
					<span>© {new Date().getFullYear()} Oh Taehun — All rights reserved</span>
					<span>Built with React · Three.js · Tailwind</span>
				</div>
			</div>
		</footer>
	);
}
